import React from 'react'
import { observer } from 'mobx-react'

import { IProps as ITableCellEditorParams } from './TableCellEditor'

import styles from './stringInput.scss'

interface IProps extends ITableCellEditorParams {
  initialValue: Buffer | Uint8Array | null
}

interface IState {
  value: string | null // Save state as a string to allow typing
}

class BytesInput extends React.PureComponent<IProps, IState> {
  private input: React.RefObject<HTMLInputElement> = React.createRef()

  constructor(props: IProps) {
    super(props)

    const { initialValue } = props
    const value =
      initialValue === undefined || initialValue === null
        ? null
        : (props.initialValue instanceof Uint8Array // Can be Uint8Array when restored from IndexedDB
            ? Buffer.from(props.initialValue)
            : props.initialValue || Buffer.from('')
          ).toString('base64')

    this.state = {
      value,
    }
  }

  // Called by ag-grid to get the final value when editing is finished
  getValue = () =>
    this.state.value ? Buffer.from(this.state.value, 'base64') : null

  focus = () => {
    this.input.current?.focus()
  }

  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { field } = this.props
    const value = e.currentTarget.value

    if (!field.isRequired && value === '') {
      // For optional fields, it is more common to want to set the value to `null` rather than an empty string, so we're manually doing that here
      this.setState({ value: null })
      return
    }

    console.log(value, Buffer.from(value, 'utf8'))
    this.setState({ value })
  }

  render() {
    const { value } = this.state

    return (
      <input
        data-cy="input--bytes"
        ref={this.input}
        className={styles.input}
        type="text"
        value={value === null || value === undefined ? '' : value}
        placeholder="null"
        onChange={this.handleChange}
      />
    )
  }
}

export default observer(BytesInput)
